import Seo from './Seo'
import { useState } from "react";
import ContainerBasic from "../components/ContainerBasic";

import Piacere from '../img/icon-piacere-di-conoscerti.png';
import Strumenti from '../img/icon-gli-strumenti-del-mestiere.png'
import Portfolio from '../img/icon-portfolio.png'
import News from '../img/icon-blog.png'

import BackHome from '../img/sfondo-chi-sono.jpg'
import BackTools from '../img/sfondo-strumenti.jpg'
import BgBlog from '../img/sfondo-blog.jpg'
import BgWeb from '../img/sfondo-web.jpg'

import Photoshop from "../img/photoshop.png";
import Illustrator from "../img/illustrator.png";
import Indesign from "../img/indesign.png";
import Xd from "../img/xd.png";
import Html from "../img/html.png";
import Css from "../img/css.png";
import Bootstrap from "../img/bootstrap.png";
import Javascript from "../img/javascript.png";
import Jquery from "../img/jquery.png";
import ReactIcon from "../img/react.png";
import Php from "../img/php.png";
import Git from "../img/git.png";
import Asp from '../img/asp_net_core.png'
import Vue from '../img/vue.png'
import Typescript from '../img/typescript.png'
import Mailchimp from '../img/mailchimp.png'
import Sql from '../img/sql.png'
import Post_gre from '../img/post_gre.png'
import Csharp from '../img/c_sharp.png'
import Github from '../img/github.png'
import wordpress from '../img/wordpress.png';
import afterEffects from '../img/after_effects.png'
import capcut from '../img/capcut.png'
import mamp from '../img/mamp.png'

import Logo from '../img/sfondo-logo-index.jpg'
import Bigliettini from '../img/sfondo-bigliettino-index.jpg'
import Volantini from '../img/sfondo-volantino-index.jpg'
import Locandine from '../img/sfondo-locandina-index.jpg'
import Manifesti from '../img/sfondo-manifesto-index.jpg'
import Depliant from '../img/sfondo-depliant-index.jpg'
import Riviste from '../img/sfondo-riviste-index.jpg'
import Vari from '../img/sfondo-gadget-index.jpg'
import Siti from '../img/sfondo-responsive-index.jpg'

import TitleSection from "../components/TitleSection";
import SlideShow from "../components/SlideShow";
import BoxMe from "../components/BoxMe";
import Background from "../components/Background";
import SoftwareCard from "../components/SoftwareCard";
import CardPortfolioHome from "../components/CardPortfolioHome";
import CardNewsHome from "../components/CardNewsHome";

import BgTipography from '../img/sfondo-blog-tipografia.jpg'
import BgLogoCuriosity from '../img/sfondo-blog-logo-curiosity.jpg'
import BgWordAdvisor from '../img/sfondo-blog-word-advisor.jpg'
import Brochure from "../components/Brochure";
import ContainerForm from "../components/ContainerForm";
import FormHome from '../components/Form';

import ImgFb from '../img/img_fb.jpg';

// import { useSelector, useDispatch } from 'react-redux';
// import { ChangeByPayload } from '../store/ActiveLinkLogic';

const Software = [
    {
      img: Photoshop,
      toggle: 'Photoshop',
      title: "Adobe Photoshop",
      description:
      "Programma principale per il fotoritocco e la creazione di layout ed elementi grafici sia per la pubblicità online che offline.",
    },
    {
      img: Illustrator,
      toggle: 'Illustrator',
      title: "Adobe Illustrator",
      description:
      "Software di elaborazione grafica vettoriale. Ideale per progettare illustrazioni o creare loghi.",
    },
    {
      img: Indesign,
      toggle: 'Indesign',
      title: "Adobe Indesign",
      description:
      "Ideato per la produzione editoriale. Fondamentale per creare qualsiasi tipo di impaginato, dal semplice biglietto da visita al più complesso magazine.",
    },
         {
      img: afterEffects,
      toggle: 'Effects',
      title: "Adobe After Effects",
      description:
      "Programma di compositing e animazione grafica utilizzato per la creazione di effetti speciali e animazioni in ambito video e multimedia.",
    },
    {
      img: capcut,
      toggle: 'Capcut',
      title: "Capcut",
      description:
      "Software di montaggio e video editing utilizzato per la creazione, la manipolazione e l'ottimizzazione di contenuti video.",
    },
    {
      img: Xd,
      toggle: 'Xd',
      title: "Adobe Xd",
      description:
      "Software della Adobe utilizzato per realizzare mockup di siti internet ed applicazioni. Ha sostituito in parte photoshop ed illustrator, grazie sopratutto all'area di prototipazione che permette di simulare l'interazione utente con il contenuto creato.",
    },
    {
      img: Html,
      toggle: 'Html',
      title: "Html",
      description:
      "Linguaggio markup per la creazione di pagine web. Fondamentale conoscerlo per creare siti da zero, senza utilizzo di cms.",
    },
    {
      img: Css,
      toggle: 'Css',
      title: "Css",
      description:
      "Detto anche 'foglio di stile', serve per definire la formattazione degli elementi presenti in una pagina Html.",
    },
    {
      img: Bootstrap,
      toggle: 'Bootstrap',
      title: "Bootstrap",
      description:
      "Libreria open source più utilizzata per facilitare lo sviluppo front-end di siti web responsive, sopratutto grazie ai molti modelli di progettazione inclusi e modificabili (es. pulsanti, moduli ecc) basati su html e css.",
    },
    {
      img: Javascript,
      toggle: 'Javascript',
      title: "Javascript",
      description:
      "Linguaggio di programmazione lato client, orientato agli oggetti e agli eventi. Fondamentale la sua applicazione per creare siti web dinamici.",
    },
    {
      img: Jquery,
      toggle: 'Jquery',
      title: "Jquery",
      description:
      "Libreria di Javascript, ci permette di semplificare la gestione e la creazione di eventi nel sito.",
    },
       {
      img: ReactIcon,
      toggle: 'React',
      title: "React",
      description:
      "Framework basato su linguaggio Javascript, utilizzato per la creazione di interfacce utente e single-page-application.",
    },
    // {
    //   img: Vue,
    //   toggle: 'Vue',
    //   title: "VUE",
    //   description:
    //   "Vue è un framework basato su linguaggio Javascript, utilizzato per la creazione di interfacce utente e single-page-application.",
    // },
    {
      img: Git,
      toggle: 'Git',
      title: "Git",
      description:
      "Software per il controllo di versione utilizzabile da interfaccia a riga di comando. Facilita il flusso di lavoro e lo sviluppo di applicazioni web.",
    },
    {
      img: Github,
      toggle: 'Github',
      title: "Github",
      description:
      "Servizio web e cloud-based che aiuta gli sviluppatori ad archiviare e gestire il loro codice e a tracciare e controllare le modifiche.",
    },
  /*
    {
      img: Asp,
      toggle: 'aspnetcore',
      title: "ASP NET .Core",
      description:
      "ASP.NET Core è un framework open source multipiattaforma e ad alte prestazioni per la creazione di app moderne abilitate per il cloud e connesse a Internet.",
    },
    */
    {
      img: Sql,
      toggle: 'Sql',
      title: "Sql",
      description:
      "SQL è un linguaggio standardizzato per database basati sul modello relazionale, progettato per operazioni Crud (create - read - update - delete).",
    },
    {
      img: Post_gre,
      toggle: 'Postgre',
      title: "Postgre Sql",
      description:
      "Sistema di gestione di database relazionali open source ad alta disponibilità, gratuito e libero.",
    },
        {
      img: Php,
      toggle: 'Php',
      title: "Php",
      description:
      "Linguaggio di programmazione lato server. Viene utilizzato maggiormente nella programmazione di pagine web dinamiche.",
    },
       {
      img: mamp,
      toggle: 'Mamp',
      title: "Mamp",
      description:
      "Un ambiente di sviluppo locale utilizzato per l'installazione e la simulazione di server web.",
    },
    {
      img: wordpress,
      toggle: 'wordpress',
      title: "WordPress",
      description:
      "Piattaforma che consente la creazione e distribuzione di un sito vetrina oppure e-commerce, con i suoi contenuti gestibili in maniera dinamica dal cliente senza conoscere codice.",
    },
       {
      img: Mailchimp,
      toggle: 'mailchimp',
      title: "Mailchimp",
      description:
      "Piattaforma utilizzata per la creazione, invio e tracciamento di campagne di email marketing.",
    },
  ];
  
const Porfolio = [
  {
    title: "Loghi",
    categoria:'Loghi',
    img: Logo,
    link: "",
  },
  {
    title: "Biglietti da Visita",
    categoria: 'Bigliettini',
    img: Bigliettini,
    link: "#",
  },
  {
    title: "Volantini",
    categoria: 'Volantini',
    img: Volantini,
    link: "#",
  },
  {
    title: "Locandine",
    categoria: "Locandine",
    img: Locandine,
    link: "#",
  },
  {
    title: "Manifesti",
    categoria: "Manifesti",
    img: Manifesti,
    link: "#",
  },
  {
    title: "Depliant",
    categoria: "Depliant",
    img: Depliant,
    link: "#",
  },
  {
    title: "Brochure - Riviste",
    categoria: "Brochure - Riviste",
    img: Riviste,
    link: "#",
  },
  {
    title: "Lavori Vari",
    categoria: "Altre lavorazioni",
    img: Vari,
    link: "#",
  },
  {
    title: "Siti e web App",
    categoria: 'Siti e Web App',
    img: Siti,
    link: "#",
  },
];

const Blog = [
  {
    title: "TIPOGRAPHY",
    categoria: 'Tipography',
    subtitle: "Alla scoperta dei font più utilizzati del momento",
    bg: BgTipography,
    link: "#",
  },
  {
    title: "LOGO CURIOSITY",
    categoria: 'Logo Curiosity',
    subtitle: "Tante curiosità sulla creazione di loghi famosi",
    bg: BgLogoCuriosity,
    link: "#",
  },
  {
    title: "WORD ADS",
    categoria: 'Word Ads',
    subtitle: "Storie sulle pubblicità di maggior successo",
    bg: BgWordAdvisor,
    link: "#ciao",
  },
];


const HomePage = () => {

    const [stateSoftware, changeSoftware] = useState("");

    const statoSoft = (para) => {
    changeSoftware(para)    
    }
        

return(
<>
<Seo
title = "Servizi di Grafica, Social e Video a Perugia e Roma | Lorenzo Giralda"
description = "Realizzazione di progetti di comunicazione visiva, campagne social e produzioni video professionali. Strategie su misura per aziende a Perugia e Roma."
keywords = "servizi grafica perugia, gestione social roma, produzione video, lorenzo giralda, comunicazione visiva"
url="https://giralda-design.web.app/"
immagine={ImgFb}
></Seo>

<SlideShow></SlideShow>

<ContainerBasic>
<TitleSection
img = {Piacere}
title="PIACERE DI CONOSCERTI"
></TitleSection>
<BoxMe></BoxMe>
</ContainerBasic>

<Background
bg = {BackTools} 
></Background>

<ContainerBasic>
<TitleSection
img = {Strumenti}
title="GLI STRUMENTI DEL MESTIERE"
></TitleSection>
{Software.map( dato =>
<SoftwareCard
toggle = {dato.toggle}
statoSoft = {statoSoft}
title = {dato.title}
description = {dato.description}
img = {dato.img}
stateSoftware = {stateSoftware}
></SoftwareCard>    
)}</ContainerBasic>

<Background
bg = {BackHome} 
></Background>

<ContainerBasic>
<TitleSection
img = {Portfolio}
title="GUARDA I MIEI LAVORI"
></TitleSection>
{Porfolio.map(dato =>
<CardPortfolioHome
title = {dato.title}
img = {dato.img}
link = {dato.link}
categoria = {dato.categoria}
></CardPortfolioHome>
)}</ContainerBasic>

<Background
bg = {BgWeb} 
></Background>

<ContainerBasic>
<TitleSection
img = ''
title="SCOPRI TUTTI I PRODOTTI E SERVIZI OFFERTI!"
></TitleSection>
<Brochure></Brochure>
</ContainerBasic>

<Background
bg = {BgBlog} 
></Background>

<ContainerBasic>
<TitleSection
img = {News}
title="NEWS CREATIVE"
></TitleSection>
{Blog.map(dato =>
<CardNewsHome
title = {dato.title}
subtitle = {dato.subtitle}
bg = {dato.bg}
link = {dato.link}
categoria = {dato.categoria}
></CardNewsHome>  
)}</ContainerBasic>
<ContainerForm>
<FormHome></FormHome>
</ContainerForm>
</>
)};

export default HomePage;